import { ReactNode } from "react";
import { GrIconType, GrSnackbarProps } from "@jnpmedi/grebob";

export type NotificationId = string;
export type NotificationType = "info" | "danger" | "success" | "warning";
export type NotificationPayload = Pick<GrSnackbarProps, "type" | "severity" | "autoHideDuration" | "message" | "anchorOrigin" | "style"> & {
  action?: ReactNode | { text: string; onClick?: () => void } | { icon: GrIconType; onClick?: () => void } | { onClick: () => void };
  id?: NotificationId;
  open?: boolean;
};
export type FxNotificationType = "SUCC" | "WARN" | "ERROR" | "INFO";
export type FxNotificationPayload = string;

export const notificationMatcher: Record<FxNotificationType, NotificationType> = {
  SUCC: "success",
  WARN: "warning",
  ERROR: "danger",
  INFO: "info",
} as const;
